<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'
import { get } from 'lodash'

export default {
  extends: BaseWidgetForm,
  data() {
    return {
      arrayFields: ['items']
    }
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Header({
              text: 'Slajdy'
            }),
            new fields.Formset({
              modelPath: [this, 'form', 'items'],
              maxItems: 3,
              items: this.form.items.map((item, i) => ({
                headerLabel: get(item, ['title_pl']),
                fields: [
                  new fields.Input({
                    label: 'Tytuł',
                    required: true,
                    type: 'textarea',
                    modelPath: [this, 'form', 'items', i, 'title'],
                    multilingual: true
                  }),
                  new fields.Image({
                    label: 'Zdjęcie',
                    modelPath: [this, 'form', 'items', i, 'image'],
                    required: true
                  }),
                  new fields.Color({
                    label: 'Kolor',
                    modelPath: [this, 'form', 'items', i, 'color'],
                    required: true
                  }),
                  new fields.Link({
                    label: 'Odnośnik slajdu',
                    modelPath: [this, 'form', 'items', i, 'title_link'],
                    hideLinkLabel: true
                  }),
                  new fields.Input({
                    label: 'Link do filmu YT',
                    modelPath: [this, 'form', 'items', i, 'video_url']
                  }),
                  new fields.Select({
                    modelPath: [this, 'form', 'items', i, 'button_text'],
                    label: 'Tekst na przycisku',
                    options: [
                      { label: 'Kup bilet', value: 'buy_ticket' },
                      { label: 'Online', value: 'online' },
                      { label: 'Zobacz więcej', value: 'see_more' },
                      { label: 'Streaming', value: 'streaming' }
                    ]
                  }),
                  new fields.Link({
                    label: 'Przycisk',
                    modelPath: [this, 'form', 'items', i, 'button'],
                    hideLinkLabel: true
                  }),
                  new fields.Input({
                    label: 'Opis',
                    modelPath: [this, 'form', 'items', i, 'description'],
                    multilingual: true
                  }),
                  new fields.Date({
                    label: 'Data od',
                    format: 'yyyy-MM-dd',
                    valueFormat: 'yyyy-MM-dd',
                    modelPath: [this, 'form', 'items', i, 'date_from']
                  }),
                  new fields.Date({
                    label: 'Data do',
                    format: 'yyyy-MM-dd',
                    valueFormat: 'yyyy-MM-dd',
                    modelPath: [this, 'form', 'items', i, 'date_to']
                  }),
                  new fields.Date({
                    label: 'Data premiery',
                    format: 'yyyy-MM-dd',
                    valueFormat: 'yyyy-MM-dd',
                    modelPath: [this, 'form', 'items', i, 'premiere_date']
                  }),
                  new fields.Switch({
                    label: 'Prapremiera',
                    modelPath: [this, 'form', 'items', i, 'is_preview']
                  }),
                  new fields.Switch({
                    label: 'Online',
                    modelPath: [this, 'form', 'items', i, 'is_online']
                  }),
                  new fields.Input({
                    label: 'Twórcy (scenarzysta / reżyser)',
                    modelPath: [this, 'form', 'items', i, 'creators'],
                    multilingual: true
                  })
                ]
              }))
            })
          ]
        }
      ]
    }
  }
}
</script>
